module.exports = __webpack_public_path__ + "img/Business-Area.dd8251a6.png";